import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEO_TRANSLATIONS = {
  'zh-HK': {
    title: 'Yosun Development Ltd. | 耀星（香港）發展有限公司',
    description:
      '耀星（香港）發展有限公司致力推廣港澳大灣區足球發展，旨在於全球發掘並培養足球人才。',
    keywords:
      '足球訓練營,青少年足球,香港足球,澳門足球,狼隊,Wolves FC,足球發展,青少年運動員',
  },
  en: {
    title: 'Yosun Development Ltd. | Football Development in Greater Bay Area',
    description:
      'Yosun Development Ltd. is dedicated to promoting football development in the Hong Kong-Macao Greater Bay Area, discovering and nurturing football talent globally.',
    keywords:
      'Football Training Camp,Youth Football,Hong Kong Football,Macao Football,Wolves FC,Football Development,Youth Athletes,Greater Bay Area',
  },
};

export default function SEO() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language as 'zh-HK' | 'en';
    const seoData = SEO_TRANSLATIONS[currentLang] || SEO_TRANSLATIONS['zh-HK'];

    // Update HTML lang attribute
    document.documentElement.lang = currentLang;

    // Update title
    document.title = seoData.title;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', seoData.description);
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', seoData.keywords);
    }
  }, [i18n.language]);

  return null; // This component doesn't render anything
}
